export const GridWrapper = ({
  children,
  className = '',
}: {
  children: JSX.Element | JSX.Element[];
  className?: string;
}) => {
  return (
    <div
      className={`
        ${className}
        grid
        grid-cols-1
        sm:grid-cols-2
        md:grid-cols-2
        lg:grid-cols-3
        gap-6
        my-6
      `}
    >
      {children}
    </div>
  );
};
